import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateRenewalSummaryReport } from '../../../services/report/ReportService';

class RenewalSummaryReport extends SpecificationReportPage {

  getFields() {
    // one year rather than a free period, per the client's correction of 21.08.2026
    return ['graveyard', 'yearAsPeriod', 'renewalType'];
  }

  getService() {
    return generateRenewalSummaryReport;
  }

  getFileName() {
    return "3A-poslata-i-naplacena-obavestenja";
  }

  getPageTitle() {
    return strings.specificationReports.renewalSummaryTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(RenewalSummaryReport)));
